import React, { useState } from "react";
import { Button } from "antd";
import { TablaProduct } from "./TablaProduct";
import { ModalNewProduct } from "./ModalNewProduct";

export const StepTwo = ({
  next,
  setDataFormProduct,
  prev,
  dataFormProduct,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  return (
    <>
      <div className="button-formTwo">
        <Button onClick={showModal} type="primary" size="large">
          Añadir producto
        </Button>
      </div>

      <TablaProduct
        dataSource={dataFormProduct}
        setDataSource={setDataFormProduct}
      />
      <div className="container-buttons-formTwo">
       
        <Button onClick={() => prev()} size="large">
          Regresar
        </Button>
        <Button type="primary" disabled={dataFormProduct.length < 1 ? true : false} onClick={() => next()} size="large">
          Siguiente
        </Button>
      </div>
      <ModalNewProduct
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        dataSource={dataFormProduct}
        setDataSource={setDataFormProduct}
      />
    </>
  );
};
